import { ImageConversions, ImageFile } from './PoiMedia';
export enum AreaTypeKey {
    Region = 'region',
    Municipality = 'municipality',
    NationalPark = 'national-park'
}

export interface GeoJsonPointObject {
    type: 'Point';
    coordinates: [number, number];
}

interface Image {
    id: number;
    mime_type: string;
    original: ImageFile;
    conversions: ImageConversions;
    created_at: string;
}

export interface AreaType {
    id: number | string;
    name: string;
    key: AreaTypeKey;
    created_at?: string;
    updated_at?: string;
}

interface Area {
    id: number | string;
    name: string;
    slug: string;
    parent_id?: number;
    parent?: Area;
    is_searchable?: boolean;
    extent?: number;
    type_id: number | string;
    type: AreaType;
    bounds_id?: number;
    pois_count?: number;
    created_at?: string;
    updated_at?: string;
    featured_image?: Image;
    centroid?: GeoJsonPointObject;
}

export default Area;
